// extracted by css-extract-rspack-plugin
var _1 = "Pr7xNLa7WqoB4_n1";
var _2 = "ovcBtigCspHXZsNr";
var _3 = "ovcBtigCspHXZsNr";
var _4 = "GYuMPxml5KgYdKan";
var _5 = "GYuMPxml5KgYdKan";
var _6 = "CMr7aZN5VAc6o3Nr";
var _7 = "CMr7aZN5VAc6o3Nr";
var _8 = "cl4W4kpo3nr41XnW";
export { _1 as "countdown", _2 as "countdown-title", _3 as "countdownTitle", _4 as "intro-text", _5 as "introText", _6 as "not-sponsored", _7 as "notSponsored", _8 as "wrapper" }
